import React, { useMemo } from "react"
import { Card, CardTitle } from "../../components/Card"
import { HeaderContent } from "../../components/Header"
import { LoadingWithLabel } from "../../components/Loading"
import { Gallery } from "../../components/ODS"
import { Table } from "../../components/Table"

import "./styles.scss"

export const EvidencesDetailsComponent = (props) => {
  return (
    <>
      <div className="gallery">
        <Gallery {...props} onClick={props.onClick} />
      </div>
      <Card className="evidence-datails-card no-border">
        <HeaderContent>
          <CardTitle title="Detalhes do Atendimento" />
        </HeaderContent>
      </Card>
    </>
  )
}

const EvidencesDetailsScreen = ({ dw, dwData, getEvidenceDetails, evidenceDetails, loading }) => {

  console.log(evidenceDetails)
  return (
    <div className="evidences-details-container" style={{ width: "100%" }}>
      <HeaderContent>
        <CardTitle title="Evidencia" />
      </HeaderContent>
      {dw?.length === 0 && loading ? (
        <LoadingWithLabel
          labelLoading="Carregando conteudo..."
          sizeSpiner="large"
          colorSpinner="primary"
        />
      ) : (
        <EvidencesDetailsComponent
          evidenceDetails={evidenceDetails}
          dw={dwData}
          onClick={getEvidenceDetails}
        />
      )}
      <div className="evidences-details-table">
        {dw?.length > 0 &&
          evidenceDetails.length > 0 &&
          evidenceDetails.map((row, index) => {
            return (
              <Table
                key={index}
                title={row?.title}
                data={row.data[row.value]}
                hasBackground={index !== 0}
                lineCaptions={row?.lineCaptions && row?.lineCaptions}
                hasPaddingLeft={index !== 0}
              />
            )
          })}
      </div>
    </div>
  )
}

export default EvidencesDetailsScreen
